import {
    Card,
    Col,
    Row,
    Button,
    Media
} from "react-bootstrap";
import { useHistory } from "react-router-dom";
import React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import OneDentInRow from './row_dents';
import FindClinicImage from './find_clinic_image';

export default function ClinicCard(props) {
    console.log(props)
    const clinics = props.clinics;
    console.log(clinics);
    let history = useHistory();
    
    const watchClinic = (clinic) => {
        history.push({
          pathname: `/clinic/${clinic.clinic_name.toLowerCase()}/`,
          state: { clinic },
        });
      };
    
        return (
            <div>
                <Card className="card">
                    <Card.Header>Best rated of 2020</Card.Header>

                    <Card.Body>
                        <Card.Text>
                        Here is the definitive list of UAE's dentists as rated by the UAE
                        community. These dentists have received great reviews from
                        customers and are currently accepting new patients. Schedule your
                        appointment today!
                        </Card.Text>
                    </Card.Body>
                </Card>
            {clinics.map((clinic) => (
            // <Link key={clinic._id} to={{
            //   pathname: `/clinic/${clinic.clinic_name.toLowerCase()}/`,
            //   state: {clinic},
            // }}>
  
            <Card key={clinic._id} className="card my-2">
              <Card.Body>
                  <Media>
                    <FindClinicImage clinic={clinic} witdh={64} height={64}/>
                    <Media.Body>
                      <Row>
                      <LinkContainer style={{ cursor: "pointer" }} to={{
                        pathname: `/clinic/${clinic.clinic_name.toLowerCase()}/`,
                        state: { clinic },
                      }}>
                        <Col sm={8} md={7} lg={8}>
                          <h5>{clinic.clinic_name}</h5>
                          <p className="text-muted">{clinic.address}</p>
                        </Col>
                      </LinkContainer>
                        <Col>
                          <Button
                            className="float-right"
                            variant="info"
                            onClick={() => watchClinic(clinic)}
                          >
                            Book Now
                          </Button>
                        </Col>
                      </Row>
                      <p>{clinic.description}</p>
                      <hr></hr>
                      <Row xs={3} md={3} lg={3}>
                        {clinic.dentists.map((dentist) => (
                            <OneDentInRow key={dentist._id} dentist={dentist} clinic={clinic}  />
                        ))}
                      </Row>
                    </Media.Body>
                  </Media>

              </Card.Body>
            </Card>

          ))}
          </div>
        );
      }
    